module.exports = __webpack_public_path__ + "img/1-4.11dfb36e.png";